import { useHistory } from "react-router";
import { ArrowLeft } from "lucide-react";
import * as Routes from "routes";
import { Button } from "@/components/ui/button";
import { CallCounter } from "./call-counter";
import { DemoControls } from "./demo-controls";
import {
  PredictiveSuburbManager,
  usePredictiveSuburbManager,
} from "./predictive-suburb-manager";
import { SuburbEntryForm } from "./suburb-entry-form";
import { VisualiseJson } from "./visualise-json";
import { VisualiseMap } from "./visualise-map";

export const predictiveSuburb = () => {
  const predictiveManager: PredictiveSuburbManager =
    usePredictiveSuburbManager();
  const history = useHistory();

  const jsonObj = predictiveManager.suggest ?? predictiveManager.locality ?? {};
  //@ts-ignore
  const { basictransaction, ...objWithoutBasictransaction } = jsonObj;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end">
        <Button
          variant="outline"
          size="sm"
          onClick={() => history.push(Routes.demosPage)}
        >
          <ArrowLeft className="size-4 mr-2" />
          Back
        </Button>
      </div>
      <DemoControls {...predictiveManager} />
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="flex flex-col gap-4">
          <SuburbEntryForm {...predictiveManager} />
          <VisualiseJson object={objWithoutBasictransaction} />
        </div>
        <div className="flex flex-col gap-4">
          <CallCounter {...predictiveManager} />
          <VisualiseMap {...predictiveManager} />
        </div>
      </div>
    </div>
  );
};
